import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import '../Utility/Normalize.js';
import { SvgWrapper } from '../Utility/SvgWrapper.js';
import '../Utility/UnstyledList.js';

const Edit = forwardRef(function Edit(props, ref) {
    return (jsx(SvgWrapper, Object.assign({ fill: "none", height: "24", viewBox: "0 0 24 24", width: "24" }, props, { ref: ref, children: jsx("path", { clipRule: "evenodd", d: "M15 10.4999L13.3284 8.8283L6 16.3283V17.9998H7.67157L15 10.4999ZM8.5 19.9998H4V15.4998L16.4142 2.8785L20.9142 7.3785L8.5 19.9998ZM18.0858 7.3785L16.4142 9.08566L14.7426 7.41409L16.4142 5.70693L18.0858 7.3785Z", fill: "curentColor", fillRule: "evenodd" }) })));
});

export { Edit as default };
//# sourceMappingURL=Edit.js.map
